import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito tener una idea antes de comprar?',
    answer: 'No. El plan incluye el sistema para elegir una idea específica y convertirla en una oferta.'
  }, {
    question: '¿Y si no tengo mucho tiempo?',
    answer: 'Funciona con 15–45 minutos al día. Constancia > perfección.'
  }, {
    question: '¿Tengo que salir en cámara?',
    answer: 'No para empezar. Incluye ideas y guiones (y opciones sin cámara).'
  }, {
    question: '¿Y si mi idea ya existe?',
    answer: 'Mejor: suele indicar mercado. Tu enfoque y tu historia te diferencian.'
  }, {
    question: '¿Esto me garantiza ingresos?',
    answer: 'No. Nadie serio puede prometer eso. Sí te da estructura para crear y publicar una oferta real.'
  }];
  return <section className="py-20 px-4 bg-cream-50" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <h2 className="text-3xl md:text-4xl font-serif text-brown-800 text-center mb-12" data-id="element-25">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-26">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-27" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl border border-cream-200 overflow-hidden" data-id="element-28">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-29">
        <span className="text-lg font-medium text-brown-800" data-id="element-30">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-stone-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-31" />
      </button>
      <AnimatePresence data-id="element-32">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-33">
            <div className="px-6 pb-6 text-stone-600 leading-relaxed" data-id="element-34">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}